import { render, staticRenderFns } from "./RegisterPhoneCard.vue?vue&type=template&id=50c27de3&scoped=true&"
import script from "./RegisterPhoneCard.vue?vue&type=script&lang=js&"
export * from "./RegisterPhoneCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c27de3",
  null
  
)

export default component.exports